<div
  class="paste-drop-zone"
  [class.paste-drop-zone--dragging]="dragging()"
  [class.paste-drop-zone--disabled]="disabled()"
  [class.paste-drop-zone--focused]="focused()"
  role="textbox"
  tabindex="0"
  contenteditable="true"
  spellcheck="false"
  [attr.aria-label]="label() | translate"
  (focus)="focused.set(true)"
  (blur)="focused.set(false)"
  (paste)="onPaste($event)"
  (keydown)="onKeydown($event)"
  (beforeinput)="$event.preventDefault()"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
>
  <span class="paste-drop-zone__label" contenteditable="false">{{
    (focused() ? focusedLabel() : label()) | translate
  }}</span>
</div>
